import { translate } from '@jsverse/transloco';
export enum Priority {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
}

export class PriorityHelper {
    static getPriorityString(status: Priority): string {
        switch (status) {
            case Priority.LOW:
                return translate('CORE.PRIORITIES.LOW');
            case Priority.MEDIUM:
                return translate('CORE.PRIORITIES.MEDIUM');
            case Priority.HIGH:
                return translate('CORE.PRIORITIES.HIGH');
            default:
                return '';
        }
    }
}
